export default __webpack_public_path__ + "static/media/CormorantGaramondLight.3a0fe986.woff2";